import { Card, Tabs } from "@shopify/polaris"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { CONFIG } from "../../../config"
import Actions from "./../../../actions"
import axios from "../../../funcs/axios"
import "./styles.scss"

function mapStateToProps(state) {
    return {
        parent_pages: state.parent_pages,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class AppHeader extends Component {
    handleTabChange = (index: number, name: string): void => {
        const { actions } = this.props
        actions.switchParentPagesAction(index)
    }

    render() {
        const { parent_pages, actions } = this.props
        let url = new URL(window.location.href)
        let arr = [...parent_pages.data]
        let shop = url.searchParams.get("shop")
        if (shop.includes("electro-5-demo.myshopify.com")) {
            arr = [
                {
                    id: "Wishlist - Compare",
                    content: "Wishlist - Compare",
                    accessibilityLabel: "Wishlist - Compare",
                    panelID: "Wishlist - Compare",
                },
                // {
                //     id: "Back in stock",
                //     content: "Back in stock",
                //     accessibilityLabel: "Back in stock",
                //     panelID: "Back in stock",
                // },
                {
                    id: "Pre-order",
                    content: "Pre-order",
                    accessibilityLabel: "Pre-order",
                    panelID: "Pre-order",
                },
                {
                    id: "Contact",
                    content: "Contact",
                    accessibilityLabel: "Contact",
                    panelID: "Contact",
                },
                {
                    id: "Notifications",
                    content: "Notifications",
                    accessibilityLabel: "Notifications",
                    panelID: "Notifications",
                },
                {
                    id: "Plan",
                    content: "Plan",
                    accessibilityLabel: "Plan",
                    panelID: "Plan",
                },
                {
                    id: "Support",
                    content: "Support",
                    accessibilityLabel: "Support",
                    panelID: "Support",
                },
                {
                    id: "App Managed",
                    content: "App Managed",
                    accessibilityLabel: "App Managed",
                    panelID: "App Managed",
                },
                {
                    id: "Integration",
                    content: "Integration",
                    accessibilityLabel: "Integration",
                    panelID: "Integration",
                },
            ]
        } else {
            arr = [
                {
                    id: "Wishlist - Compare",
                    content: "Wishlist - Compare",
                    accessibilityLabel: "Wishlist - Compare",
                    panelID: "Wishlist - Compare",
                },
                // {
                //     id: "Back in stock",
                //     content: "Back in stock",
                //     accessibilityLabel: "Back in stock",
                //     panelID: "Back in stock",
                // },
                {
                    id: "Plan",
                    content: "Plan",
                    accessibilityLabel: "Plan",
                    panelID: "Plan",
                },
                {
                    id: "Support",
                    content: "Support",
                    accessibilityLabel: "Support",
                    panelID: "Support",
                },
                {
                    id: "Integration",
                    content: "Integration",
                    accessibilityLabel: "Integration",
                    panelID: "Integration",
                },
            ]
        }

        return (
            <div className="yta-header">
                <div className="page-wrapper">
                    <div className="header-logo">
                        <div className="app-name">{CONFIG.APP_NAME}</div>
                        {/* <img alt={CONFIG.APP_NAME} src={Images.app_logo} /> */}
                        <svg
                            style={{ marginLeft: "-65px" }}
                            width="48"
                            height="48"
                            viewBox="0 0 641 641"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M467.729 297.464C474.74 285.445 484.756 275.43 496.775 267.417V27.0421C496.775 16.0249 487.76 7.01086 476.743 7.01086H27.0417C16.0246 7.01086 7.0105 16.0249 7.0105 27.0421V613.958C7.0105 624.975 16.0246 633.989 27.0417 633.989H476.743C487.76 633.989 496.775 624.975 496.775 613.958V528.825C479.748 541.845 467.729 548.856 467.729 548.856C467.729 548.856 459.717 543.848 447.698 535.836V574.897H56.087V46.0718H447.698V273.426C455.711 280.437 461.72 288.45 467.729 297.464Z"
                                fill="white"
                            />
                            <path
                                d="M543.848 253.395C525.82 253.395 509.795 258.403 495.773 267.417C483.755 275.43 473.739 285.445 466.728 297.464C461.72 288.45 454.709 281.439 446.697 274.428C430.672 261.408 411.642 253.395 389.608 253.395C340.531 253.395 300.469 293.458 300.469 342.534C300.469 425.664 403.63 505.789 447.699 536.837C459.717 544.85 467.73 549.858 467.73 549.858C467.73 549.858 479.749 542.847 496.775 529.826C544.85 494.772 633.989 419.655 633.989 342.534C633.989 293.458 593.926 253.395 543.848 253.395ZM467.73 470.734L385.602 387.605L425.664 347.542L467.73 389.608L544.85 313.489L584.912 353.551L467.73 470.734Z"
                                fill="#FAB87E"
                            />
                            <path
                                d="M115.18 164.256C126.243 164.256 135.211 155.288 135.211 144.225C135.211 133.162 126.243 124.194 115.18 124.194C104.117 124.194 95.1484 133.162 95.1484 144.225C95.1484 155.288 104.117 164.256 115.18 164.256Z"
                                fill="white"
                            />
                            <path
                                d="M115.18 233.364C126.243 233.364 135.211 224.396 135.211 213.333C135.211 202.27 126.243 193.302 115.18 193.302C104.117 193.302 95.1484 202.27 95.1484 213.333C95.1484 224.396 104.117 233.364 115.18 233.364Z"
                                fill="white"
                            />
                            <path
                                d="M115.18 301.47C126.243 301.47 135.211 292.502 135.211 281.439C135.211 270.376 126.243 261.408 115.18 261.408C104.117 261.408 95.1484 270.376 95.1484 281.439C95.1484 292.502 104.117 301.47 115.18 301.47Z"
                                fill="white"
                            />
                            <path
                                d="M115.18 369.577C126.243 369.577 135.211 360.608 135.211 349.545C135.211 338.482 126.243 329.514 115.18 329.514C104.117 329.514 95.1484 338.482 95.1484 349.545C95.1484 360.608 104.117 369.577 115.18 369.577Z"
                                fill="white"
                            />
                            <path
                                d="M115.18 438.684C126.243 438.684 135.211 429.716 135.211 418.653C135.211 407.59 126.243 398.622 115.18 398.622C104.117 398.622 95.1484 407.59 95.1484 418.653C95.1484 429.716 104.117 438.684 115.18 438.684Z"
                                fill="white"
                            />
                            <path
                                d="M115.18 506.791C126.243 506.791 135.211 497.822 135.211 486.759C135.211 475.696 126.243 466.728 115.18 466.728C104.117 466.728 95.1484 475.696 95.1484 486.759C95.1484 497.822 104.117 506.791 115.18 506.791Z"
                                fill="white"
                            />
                            <path
                                d="M406.634 137.214H318.496V152.237H406.634V137.214Z"
                                fill="white"
                            />
                            <path
                                d="M293.458 137.214H166.26V152.237H293.458V137.214Z"
                                fill="white"
                            />
                            <path
                                d="M406.633 205.32H269.419V220.344H406.633V205.32Z"
                                fill="white"
                            />
                            <path
                                d="M244.381 205.32H166.259V220.344H244.381V205.32Z"
                                fill="white"
                            />
                            <path
                                d="M284.444 274.428H166.259V289.451H284.444V274.428Z"
                                fill="white"
                            />
                            <path
                                d="M269.42 342.534H166.259V357.558H269.42V342.534Z"
                                fill="white"
                            />
                            <path
                                d="M288.45 410.641H166.259V425.664H288.45V410.641Z"
                                fill="white"
                            />
                            <path
                                d="M337.527 479.748H166.259V494.772H337.527V479.748Z"
                                fill="white"
                            />
                            <path
                                d="M641 342.534C641 289.452 597.933 245.383 543.848 245.383C529.826 245.383 515.805 248.387 503.786 254.397V27.0422C503.786 12.0187 491.767 0 476.744 0H27.0423C12.0189 0 0 12.0187 0 27.0422V613.958C0 628.981 12.0189 641 27.0423 641H476.744C491.767 641 503.786 628.981 503.786 613.958V532.831C553.864 496.775 641 421.658 641 342.534ZM142.222 15.0234H362.566V47.0734C362.566 65.1015 348.544 79.1234 330.516 79.1234H174.272C156.244 79.1234 142.222 65.1015 142.222 47.0734V15.0234ZM488.762 613.958C488.762 620.969 484.756 625.977 477.745 625.977H28.0436C21.0327 625.977 16.0251 620.969 16.0251 613.958V27.0422C16.0251 20.0312 21.0327 15.0234 28.0436 15.0234H128.2V47.0734C128.2 73.114 149.233 93.1453 174.272 93.1453H330.516C356.556 93.1453 376.588 72.1125 376.588 47.0734V15.0234H476.744C483.755 15.0234 488.762 20.0312 488.762 27.0422V263.411C480.75 269.42 472.738 276.431 466.728 284.444C448.7 260.406 419.655 246.384 389.608 246.384C336.525 246.384 292.456 289.452 292.456 343.536C292.456 451.705 455.711 552.862 462.722 556.869C463.724 557.87 464.725 557.87 466.728 557.87C468.731 557.87 469.733 557.87 470.734 556.869C471.736 555.867 478.747 551.861 488.762 544.85V613.958ZM467.73 540.844C442.691 524.819 308.481 433.677 308.481 342.534C308.481 297.464 345.539 260.406 390.609 260.406C419.655 260.406 446.697 275.43 461.72 300.469C464.725 304.475 471.736 304.475 474.741 300.469C489.764 275.43 516.806 260.406 545.852 260.406C590.922 260.406 627.98 297.464 627.98 342.534C625.977 433.677 491.767 524.819 467.73 540.844Z"
                                fill="white"
                            />
                        </svg>
                        <div className="actions">
                            {window.shopOrigin === 'sorento-1987.myshopify.com'? (
                                <button onClick={() => {
                                    axios.get(`${window.SHOPIFY_APP_HOST}/admin/check-konva`).then((res) => {
                                        
                                    })
                                }}>Test KONVA</button>
                            ) : null}
                            
                            <div
                                onClick={() =>
                                    window.open(
                                        "https://support.arenacommerce.com/support/tickets/new",
                                        "_blank",
                                    )
                                }
                            >
                                Request a free installation
                            </div>
                            <div onClick={() => actions.switchParentPagesAction(6)}>Need help?</div>
                        </div>
                    </div>
                    <div className="header-tabs-block">
                        <Card>
                            <Tabs
                                tabs={arr}
                                selected={parent_pages.selected}
                                onSelect={(index) =>
                                    this.handleTabChange(index, parent_pages.selected)
                                }
                            />
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader)
